import { Navigate, useLocation, useParams } from "react-router";
import { useUrlProvider } from "./useUrlProvider";

// The customer and other lists were merged into the external list and their entities moved under the external
// detail routes, but links to the old pages live on in bookmarks and sent emails.
function RedirectLegacyLegalEntityUrls() {
    const { "*": legalEntityPath } = useParams();
    const { search } = useLocation();
    const { getExternalLegalEntities } = useUrlProvider();

    if (!legalEntityPath) {
        return <Navigate to={getExternalLegalEntities()} replace />;
    }

    return <Navigate to={`/privacy/legal-entities/${legalEntityPath}${search}`} replace />;
}

export default RedirectLegacyLegalEntityUrls;
